<template>
  <div id="search-result-container">
    <!--top search container-->
    <div class="model-top-menu-container">
      <search-bar @search="onSearchBtnClick"></search-bar>
    </div>
    <!--model list container-->
    <div class="model-list-container">
      <ul class="model-list">
        <model-item
          v-for="(item, index) in modelList"
          :ref="'modelItem' + index"
          :key="item.id"
          :data="item"
          @on-collect-change="
            onCollectChange($event, item.userModelPkId, index)
          "
          @allocationMember="
            onAllocationMember(item.userModelPkId, index, item.modelDistributor)
          "
          @editorArea="
            onEditorArea(item.userModelPkId, index, item.size, item.price)
          "
          @showModel="
            onShowModel(item.userModelPkId, index, item.name, item.show)
          "
          @onPreviewClick="onPreviewClick($event)"
          @handleModelDelete="handleModelDelete($event)"
        >
        </model-item>
      </ul>
      <!--model list pagebar-->
      <div class="model-list-pagebar-container">
        <!-- <Page :total="page.total" show-elevator show-total show-sizer :page-size="page.pageSize" :page-size-opts="page.pageSizeOption"></Page> -->
        <PagerComponent
          :currentPager="page.currentPage"
          :totalCount="page.total"
          :currentUnit="page.pageSize"
          :listOfBars="page.pageSizeOption"
          @on-getCurrentPager="onPageChange"
          @on-changeUnit="onPageSizeChange"
        ></PagerComponent>
      </div>
    </div>
    <div class="bottom-copyright-container">
      <copyright></copyright>
    </div>
    <Modal
      class="allocation-pop model-center-pop"
      class-name="allocation-pop-wrap"
      v-model="isShowAllocationPop"
      :loading="true"
      :transfer="false"
      @on-visible-change="allocationClose"
      width="400"
    >
      <template v-slot:header>
        <span class="title">分配所属人</span>
      </template>
      <template v-slot:close>
        <div class="iconfont icon-close" @click="allocationClose(false)"></div>
      </template>
      <template>
        <div class="allocation-content">
          <span class="allocation-text">选择所属人</span>
          <Select
            class="allocation-select"
            v-model="allocationFormData.modelDistributor"
            filterable
            clearable
            :loading="userListloading"
          >
            <Option
              class="allocation-option"
              v-for="item in userList"
              :value="item.userPkId"
              :key="item.userPkId"
              >{{ item.userName }}</Option
            >
          </Select>
          <span class="allocation-search">搜索</span>
        </div>
        <div style="padding-top:20px;" v-if="authority !== 'USER' && authority !== 'SUB_USER'">
          <span style="padding:0 20px">分配模式</span>
          <RadioGroup style="" v-model="allocationFormData.mode" :on-change="onAllocationModeChange(allocationFormData.mode)">
            <Radio label="分配"></Radio>
            <Radio label="分享"></Radio>
          </RadioGroup>
        </div>
        <div class="allocation-tips">注：直接选择或搜索选择</div>
      </template>
      <template v-slot:footer>
        <Button shape="circle" @click="allocationClose(false)">取消</Button>
        <Button type="primary" shape="circle" @click="onAllocationMemberOk"
          >确定</Button
        >
      </template>
    </Modal>
    <Modal
      class="model-center-pop area-pop"
      class-name="area-pop-wrap"
      v-model="isShowArea"
      :loading="true"
      :transfer="false"
      @on-visible-change="areaClose"
      width="400"
    >
      <template v-slot:header>
        <span class="title">修改面积/价格</span>
      </template>
      <template v-slot:close>
        <div class="iconfont icon-close" @click="areaClose(false)"></div>
      </template>
      <template>
        <div class="area-content">
          <div class="pop-edit-area">
            <span class="pop-edit-area-field">修改面积</span>
            <input
              type="text"
              class="pop-edit-area-input"
              style="width: 214px;height: 30px;border: solid 1px #e5e5e5"
              :value="areaFormData.area"
              @input="onAreaInput"
              ref="popAreaInput"
            />
            <span class="pop-edit-area-company">m²</span>
          </div>
          <div class="pop-edit-price">
            <div class="pop-edit-price-pricing-method">
              <span class="pop-edit-price-field">修改价格</span>
              <RadioGroup
                v-model="areaFormData.method"
                class="pop-edit-price-pricing-method-radio"
              >
                <Radio label="0">按面积计算</Radio>
                <Radio label="1">手动输入价格</Radio>
              </RadioGroup>
            </div>
            <input
              type="text"
              class="pop-edit-price-input"
              style="width: 214px;height: 30px;border: solid 1px #e5e5e5"
              :value="areaFormData.price"
              @input="onPriceInput"
              ref="popPriceInput"
            />
          </div>
        </div>
      </template>
      <template v-slot:footer>
        <Button shape="circle" @click="areaClose(false)">取消</Button>
        <Button type="primary" shape="circle" @click="onAreaOk">确定</Button>
      </template>
    </Modal>
    <Modal
      class="show-model-pop model-center-pop"
      class-name="show-model-pop-wrap"
      v-model="isShowModelPop"
      :loading="true"
      :transfer="false"
      @on-visible-change="showModelclose"
      width="400"
    >
      <template v-slot:header>
        <span class="title">显示/隐藏</span>
      </template>
      <template v-slot:close>
        <div class="iconfont icon-close" @click="showModelclose(false)"></div>
      </template>
      <template>
        <div class="show-model-pop-content">
          是否{{ showModelFormData.isShowModel ? "隐藏" : "显示"
          }}{{ showModelFormData.modelName }}
        </div>
        <div class="show-model-pop-tips">注：隐藏后用户将看不到该模型</div>
      </template>
      <template v-slot:footer>
        <Button shape="circle" @click="showModelclose(false)">取消</Button>
        <Button type="primary" shape="circle" @click="onShowModelOk"
          >确定</Button
        >
      </template>
    </Modal>
    <ModelPreview
      v-model="previewIfrData.isShowPreview"
      :modelId="previewIfrData.modelId"
    />
    <Modal
      class="show-model-pop model-center-pop"
      v-model="deleteConfirmData.isShowDeleteConfirm"
      :transfer="false"
      width="200"
    >
      <template v-slot:header>
        <span class="title">删除模型</span>
      </template>
      <template>
        <br />
        <div style="text-align:center;">确认删除该模型吗?</div>
        <br />
      </template>
      <template v-slot:footer>
        <Button
          shape="circle"
          @click="deleteConfirmData.isShowDeleteConfirm = false"
          >取消</Button
        >
        <Button type="primary" shape="circle" @click="onDeleteConfirmOk"
          >确定</Button
        >
      </template>
    </Modal>
  </div>
</template>

<script>
import PagerComponent from "@/components/PagerComponent.vue";
import searchBar from "@/components/new/model/SearchBar";
import modelItem from "@/components/new/model/ModelItem";
import copyright from "@/components/new/home/Copyright";
import ModelPreview from "../../ModelPreview";

let _subUserList=[],_allUserListExSub=[]

export default {
  name: "searchResult",
  components: {
    searchBar,
    modelItem,
    copyright,
    PagerComponent,
    ModelPreview
  },
  data() {
    return {
      id: 0,
      modelList: [],
      page: {
        currentPage: 1,
        pageSize: 15,
        pageSizeOption: [5, 10, 15],
        total: 0
      },
      enterSearchKey: "",
      isShowAllocationPop: false,
      allocationFormData: {
        mode:'分享',
        userModelPkId: -1,
        refIdx: -1,
        modelDistributor: -1
      },
      userList: [],
      userListloading:false,
      isShowArea: false,
      areaFormData: {
        userModelPkId: -1,
        refIdx: -1,
        area: -1,
        method: "-1",
        price: -1
      },
      isShowModelPop: false,
      showModelFormData: {
        userModelPkId: -1,
        modelName: "",
        refIdx: -1,
        isShowModel: true
      },
      previewIfrData: {
        isShowPreview: false,
        modelId: ""
      },
      deleteConfirmData: {
        isShowDeleteConfirm: false,
        modelPkId: -1
      }
    };
  },
  computed:{
    authority(){
      return handleLocalStorage.getSomeItem("userInfo").authority
    }
  },
  // computed: {
  //   //本页数据
  //   processedModelList() {
  //     return this.modelList.slice((this.page.currentPage - 1) * this.page.pageSize, this.page.currentPage * this.page.pageSize)
  //   }
  //   // {
  //   //   let hasEmptyEl = false,
  //   //     start = (this.page.currentPage - 1) * this.page.pageSize,
  //   //     end = this.page.currentPage * this.page.pageSize
  //   //   //处理end的最大值为数据总数
  //   //   end = end <= this.page.total ? end : this.page.total
  //   //   //从本地数据截取本页数据
  //   //   let data = this.modelList.slice(start,end)
  //   //   //判断本页数据中是否含有空数据,如有则请求新数据
  //   //   for(let ele of data){
  //   //     if(!ele){
  //   //       hasEmptyEl = true
  //   //       break
  //   //     }
  //   //   }
  //   //   if(hasEmptyEl){
  //   //     //如请求新数据，则更新本地数据，并重新截取本页数据
  //   //     await console.log(`本地数据不足,请求数据——curPage:${this.page.currentPage},pageSize:${this.page.pageSize}`)
  //   //     //this.modelList.splice(start,data.length,...[responseArr])
  //   //     //data = this.modelList.slice(start,end)
  //   //   }
  //   //   return data
  //   // }
  // },
  created() {
    //创建和远程数据总数相同长度的本地空数组（本地数据）
    //this.modelList = new Array(this.page.total)
    // console.log(this.$route);
    this.enterSearchKey = this.$route.query.search;
    this.initPageData();
    this.searchModel(this.enterSearchKey);
    this.userListloading = true
    if(this.authority !== 'USER' && this.authority !== 'SUB_USER'){
      const userId = handleLocalStorage.getSomeItem("userInfo").userId;
      Promise.all([
        this.$http("/api/user/getAllUserList").then(res=>{
          if(res.data.status === 200){
            _allUserListExSub = res.data.data.map(userItem => ({
              userName: userItem.userName,
              userPkId: userItem.userPkId
            })).filter(userItem => userItem.userPkId !== userId)
          }else{
            this.$Message.error("账号数据获取失败");
          }
        }).catch(()=>{
          this.$Message.error("账号数据获取异常");
        }),
        this.$http("/api/user/getSubUserList").then(res=>{
          if(res.data.status === 200){
            _subUserList =  [{
              userName:'--取消分享--',
              userPkId: -1
            }].concat(res.data.data.map(userItem => {
              return {
                userName: userItem.userName,
                userPkId: userItem.userPkId
              }
            }))
          }else{
            this.$Message.error("子账号数据获取失败");
          }
        }).catch(()=>{
          this.$Message.error("子账号数据获取异常");
        })
      ]).then(()=>{
        this.userListloading = false
      })
    }else if(this.authority !== 'SUB_USER'){
       this.$http("/api/user/getSubUserList").then(res=>{
        if(res.data.status === 200){
          _subUserList =  [{
            userName:'',
            userPkId: -1
          }].concat(res.data.data.map(userItem => {
            return {
              userName: userItem.userName,
              userPkId: userItem.userPkId
            }
          }))
          this.userListloading = false
        }else{
          this.$Message.error("子账号数据获取失败");
        }
      }).catch(()=>{
        this.$Message.error("子账号数据获取异常");
      })
    }

    // this.$http("/api/user/allSubUser")
    //   .then(res => {
    //     if (res.data.status === 200) {
    //       this.userList = res.data.data.map(userItem => ({
    //         userName: userItem.userName,
    //         userPkId: userItem.userPkId
    //       }));
    //     } else {
    //       this.$Message.error("账号数据获取失败");
    //     }
    //   })
    //   .catch(() => {
    //     this.$Message.error("账号数据获取异常");
    //   });
  },
  // beforeRouteEnter(to,from,next){
  //     // this.searchKey = this.$route.
  //     console.log(123456);
  //     console.log($route);
  //     next()
  // },
  methods: {
    // 初始化页面数据u
    initPageData() {
      this.id = JSON.parse(window.localStorage.getItem("userInfo")).userId;
    },
    // 根据关键字搜索获取数据
    searchModel(keywords) {
      if (keywords != null && keywords != "" && keywords != undefined) {
        let param = {
          offset: (this.page.currentPage - 1) * this.page.pageSize,
          limit: this.page.pageSize,
          userPkId: this.id,
          keyword: keywords
        };
        this.$http("/api/userModel/pageParam", param)
          .then(res => {
            if (res.data.status === 200) {
              let data = res.data.data.records.map(item => {
                return {
                  id: item.modelPkId,
                  userModelPkId: item.userModelPkId,
                  cover: item.model.pcBg,
                  size: item.model.modelArea,
                  price: item.model.modelPrice,
                  pv: item.pageVisitNum,
                  uv: item.userVisitNum,
                  name: item.model.modelName,
                  date: item.latestEditTime,
                  show: item.model.isShow,
                  collect: item.isCollection,
                  owner: item.editorName
                };
              });
              this.modelList = data;
              this.page.total = res.data.data.total;
              this.$Message.info("模型搜索完成");
            } else {
              this.$Message.error("模型获取失败");
            }
          })
          .catch(error => {
            console.error("模型搜索异常");
          });
      }
    },
    onPageChange(page) {
      this.page.currentPage = page;
      this.searchModel(this.enterSearchKey);
    },
    onPageSizeChange(pageSize, curPage) {
      this.page.pageSize = pageSize;
      this.page.currentPage = curPage;
      this.searchModel(this.enterSearchKey);
    },
    onCollectChange(isCollect, userModelPkId, refIdx) {
      this.$http(
        "/api/userModel/modify",
        {
          userModelPkId: userModelPkId,
          isCollection: isCollect ? 1 : 0
        },
        "PUT"
      )
        .then(res => {
          if (res.data.status === 200) {
            this.$refs["modelItem" + refIdx][0].collectModelDone(isCollect);
            // this.modelList.splice(refIdx,1)
          } else {
            this.$Message.error("模型收藏信息修改失败");
            this.$refs["modelItem" + refIdx][0].collectModelDone(!isCollect);
          }
        })
        .catch(() => {
          this.$Message.error("模型收藏信息修改异常");
          this.$refs["modelItem" + refIdx][0].collectModelDone(!isCollect);
        });
    },
    // onShowChang(isShow,userModelPkId,refIdx){
    //  this.$http('/api/userModel/modify',{
    //     userModelPkId:userModelPkId,
    //     isShow:isShow ? 1 : 0
    //   },'PUT')
    //   .then(res =>{
    //     if(res.data.status === 200){
    //       this.$refs['modelItem'+refIdx][0].showModelDone(isShow)
    //     }else{
    //       this.$refs['modelItem'+refIdx][0].showModelDone(!isShow)
    //       this.$Message.error('模型信息修改失败')
    //     }
    //   })
    //   .catch(()=>{
    //     this.$refs['modelItem'+refIdx][0].showModelDone(!isShow)
    //     this.$Message.error('模型信息修改异常')
    //   })
    // },
    onSearchBtnClick(key) {
      this.$router.push({
        path: "/model/search_result",
        query: { search: key }
      });
      this.searchModel(key);
    },
     //打开分配弹窗
    onAllocationMember(userModelPkId, refIdx, modelDistributor) {
      if (this.authority === "SUB_USER") {
        this.$Message.warning("无权分配");
      } else {
        this.userList = _subUserList
        this.isShowAllocationPop = true;
        this.allocationFormData.userModelPkId = userModelPkId;
        this.allocationFormData.refIdx = refIdx;
        this.allocationFormData.modelDistributor = modelDistributor;
      }
    },
    onAllocationModeChange(mode){
      if(mode === "分享"){
        this.userList = _subUserList
      }else{
        this.userList = _allUserListExSub
      }
    },
    //分配弹窗确认
    onAllocationMemberOk() {
      const userIdx = this.userList.findIndex(
        userItem =>
          userItem.userPkId === this.allocationFormData.modelDistributor
      );
      const editorName = this.userList[userIdx].userName;
      let allocationHttp = null
      if(this.allocationFormData.mode === "分享"){
        allocationHttp = this.$http(
          "/api/userModel/share",
          {
            userModelPkId: this.allocationFormData.userModelPkId,
            editorName: editorName,
            // modelDistributor: this.allocationFormData.modelDistributor,
            userPkId:this.allocationFormData.modelDistributor
          },
          "POST"
        )
      }else if(this.allocationFormData.mode === "分配"){
        allocationHttp = this.$http(
          "/api/userModel/assign",
          {
            userModelPkId: this.allocationFormData.userModelPkId,
            editorName: editorName,
            // modelDistributor: this.allocationFormData.modelDistributor,
            userPkId:this.allocationFormData.modelDistributor
          },
          "PUT"
        )
      }else{
        this.$Message.error("所有人分配模式异常");
        return
      }
      allocationHttp.then(res => {
        if (res.data.status === 200) {
          // this.modelList[this.allocationFormData.refIdx].owner = editorName;
          // this.modelList[
          //   this.allocationFormData.refIdx
          // ].modelDistributor = this.allocationFormData.modelDistributor;
          // // console.log(this.$refs[('modelItem' + this.allocationFormData.refIdx)][0]);
          // this.$refs[
          //   "modelItem" + this.allocationFormData.refIdx
          // ][0].initData();
          this.getModelItemsData()
          this.$Message.info("所有人分配成功");
          this.allocationClose(false);
        } else {
          this.$Message.error("所有人分配失败");
        }
      })
      .catch(() => {
        this.$Message.error("所有人分配异常");
      });
    },
    allocationClose(isShow) {
      if (!isShow) {
        this.isShowAllocationPop = false;
        this.allocationFormData = {
          mode:'分享',
          userModelPkId: -1,
          refIdx: -1,
          modelDistributor: -1
        };
      }
    },
    onEditorArea(userModelPkId, refIdx, area, price) {
      this.isShowArea = true;
      this.areaFormData = {
        userModelPkId: userModelPkId,
        refIdx: refIdx,
        area: this.modelList[refIdx].size,
        method: "1",
        price: this.modelList[refIdx].price
      };
    },
    onAreaOk() {
      const data = {
        userModelPkId: this.areaFormData.userModelPkId,
        modelArea: this.areaFormData.area * 1,
        modelPrice:
          this.areaFormData.method === "1"
            ? this.areaFormData.price * 1
            : this.areaFormData.method === "0"
            ? this.areaFormData.price * this.areaFormData.area
            : ""
      };
      this.$http("/api/userModel/modify", data, "PUT")
        .then(res => {
          if (res.data.status === 200) {
            this.modelList[this.areaFormData.refIdx].size = data.modelArea;
            this.modelList[this.areaFormData.refIdx].price = data.modelPrice;
            this.$refs["modelItem" + this.areaFormData.refIdx][0].initData();
            this.$Message.info("面积/价格修改成功");
            this.areaClose(false);
          } else {
            this.$Message.error("面积/价格修改失败");
          }
        })
        .catch(() => {
          this.$Message.error("面积/价格修改异常");
        });
    },
    areaClose(isShow) {
      if (!isShow) {
        this.isShowArea = false;
        this.areaFormData = {
          userModelPkId: -1,
          refIdx: -1,
          area: -1,
          method: "-1",
          price: -1
        };
      }
    },
    onAreaInput() {
      if (Number.isNaN(this.$refs.popAreaInput.value * 1)) {
        this.$refs.popAreaInput.value = this.areaFormData.area;
      } else {
        this.areaFormData.area = this.$refs.popAreaInput.value * 1;
      }
    },
    onPriceInput() {
      if (Number.isNaN(this.$refs.popPriceInput.value * 1)) {
        this.$refs.popPriceInput.value = this.areaFormData.price;
      } else {
        this.areaFormData.price = this.$refs.popPriceInput.value * 1;
      }
    },
    onShowModel(userModelPkId, refIdx, modelName, isShowModel) {
      this.isShowModelPop = true;
      this.showModelFormData = {
        userModelPkId: userModelPkId,
        modelName: modelName,
        refIdx: refIdx,
        isShowModel: isShowModel
      };
    },
    onShowModelOk() {
      const data = {
        userModelPkId: this.showModelFormData.userModelPkId,
        //取反
        isShow: this.showModelFormData.isShowModel ? 0 : 1
      };
      this.$http("/api/userModel/modify", data, "PUT")
        .then(res => {
          if (res.data.status === 200) {
            this.modelList[this.showModelFormData.refIdx].show = data.isShow
              ? true
              : false;
            this.$refs[
              "modelItem" + this.showModelFormData.refIdx
            ][0].initData();
            this.$Message.info("模型显示状态修改成功");
            this.showModelclose(false);
          } else {
            this.$Message.error("模型显示状态修改失败");
          }
        })
        .catch(() => {
          this.$Message.error("模型显示状态修改异常");
        });
    },
    showModelclose(isShow) {
      if (!isShow) {
        this.isShowModelPop = false;
        this.showModelFormData = {
          userModelPkId: -1,
          modelName: "",
          refIdx: -1,
          isShowModel: true
        };
      }
    },
    onPreviewClick(modelId) {
      this.previewIfrData.modelId = modelId;
      this.previewIfrData.isShowPreview = true;
    },
    handleModelDelete(modelPkId) {
      if(this.authority !== 'USER' && this.authority !== 'SUB_USER'){
        this.deleteConfirmData.isShowDeleteConfirm = true;
        this.deleteConfirmData.modelPkId = modelPkId;
      }else{
        this.$Message.error("非管理员无权删除模型");
      }
    },
    onDeleteConfirmOk() {
      const data = { modelPkId: this.deleteConfirmData.modelPkId };
      this.$http("/api/model/remove", data, "POST")
        .then(res => {
          if (res.data.status === 200) {
            this.$Message.info("模型删除成功");
            this.getModelItemsData();
          } else {
            this.$Message.error("模型删除失败");
          }
        })
        .catch(() => {
          this.$Message.error("模型删除异常");
        })
        .finally(() => {
          this.deleteConfirmData = {
            isShowDeleteConfirm: false,
            modelPkId: -1
          };
        });
    }
  }
};
</script>

<style
  scoped
  src="../../../../../../assets/css/components/new/home/model/index/search_result/SearchResult.css"
></style>
